import React from 'react';

interface IProps {
  fillColor?: string;
}

const MoveMiddleIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.7465 0C11.3824 0 11.8979 0.515504 11.8979 1.15141V6.14086H16.1198C16.5437 6.14086 16.8874 6.48453 16.8874 6.90847C16.8874 7.33241 16.5437 7.67608 16.1198 7.67608H11.8979V12.6655C11.8979 13.3014 11.3824 13.8169 10.7465 13.8169H6.14086C5.50495 13.8169 4.98945 13.3014 4.98945 12.6655V7.67608H0.767608C0.34367 7.67608 0 7.33241 0 6.90847C0 6.48453 0.34367 6.14086 0.767608 6.14086H4.98945V1.15141C4.98945 0.515504 5.50495 0 6.14086 0H10.7465Z" fill={props.fillColor ?? "#424C57"}/>
    </svg>
  )
}

export default MoveMiddleIcon;
